import axios from "axios";

// In development (running on localhost), always talk to the local backend.
// In production, use REACT_APP_API_URL or fall back to "/api".
const isBrowser = typeof window !== "undefined";
const isLocalhost =
  isBrowser &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

const apiBaseUrl = isLocalhost
  ? "http://localhost:5000/api"
  : process.env.REACT_APP_API_URL || "/api";

export const api = axios.create({
  baseURL: apiBaseUrl,
});
export const apiUrl = apiBaseUrl;

// Image base URLs: try production first, then fallback if load fails
export const imageBaseURLProduction =
  process.env.REACT_APP_IMAGE_BASE_URL || "https://api.hamsalomi.org/";
export const imageBaseURLFallback =
  process.env.REACT_APP_IMAGE_FALLBACK_URL || "http://localhost:5000/";

// Legacy: primary base URL (used where fallback is not needed, e.g. edit form preview)
export const baseURL =
  process.env.REACT_APP_BASE_URL ||
  (isLocalhost ? "http://localhost:5000/" : "https://api.hamsalomi.org/");

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["x-auth-token"] = token;
  }
  return config;
});

export const callAPi = axios.create({
  baseURL: apiUrl,
  headers: {
    "Content-type": "application/json",
    "ngrok-skip-browser-warning": "69420", // Adding custom header
  },
});
callAPi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token && token !== undefined) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Do NOT set Content-Type for multipart: axios must set it with boundary when data is FormData
export const callAPiMultiPart = axios.create({
  baseURL: apiUrl,
  headers: {
    "ngrok-skip-browser-warning": "69420",
  },
});

callAPiMultiPart.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token && token !== undefined) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Let axios set Content-Type with boundary when sending FormData
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const fetchHomeData = () => api.get("/home");
export const fetchAnnouncements = () => api.get("/announcements");
export const fetchBoardMembers = () => api.get("/board-members");
export const fetchGallery = () => api.get("/gallery");
export const fetchTribute = () => api.get("/tribute");

// Admin API calls
export const login = (credentials) => callAPi.post("/admin/login", credentials);
export const fetchDashboardData = () => api.get("/admin/dashboard");

// Announcements
export const createAnnouncement = (formData) =>
  api.post("/admin/announcements", formData);
export const updateAnnouncement = (id, formData) =>
  api.put(`/admin/announcements/${id}`, formData);
export const deleteAnnouncement = (id) =>
  api.delete(`/admin/announcements/${id}`);

// Board Members
export const createBoardMember = (formData) =>
  api.post("/admin/board-members", formData);
export const updateBoardMember = (id, formData) =>
  api.put(`/admin/board-members/${id}`, formData);
export const deleteBoardMember = (id) =>
  api.delete(`/admin/board-members/${id}`);

// Gallery
export const uploadGalleryImage = (formData) =>
  api.post("/admin/gallery", formData);
export const deleteGalleryImage = (id) => api.delete(`/admin/gallery/${id}`);

// Tribute
export const createTribute = (formData) => api.post("/admin/tribute", formData);
export const updateTribute = (id, formData) =>
  api.put(`/admin/tribute/${id}`, formData);
